export enum DashboardType {
  OVERVIEW = 'overview',
  OE_OVERVIEW = 'framework/trm_control_oe_check',
  OE_DETAIL = 'control/trm_control_oe_check',
  OE_OVERVIEW_BY_LABEL = 'label_overview/trm_control_oe_check',
  OE_DETAIL_BY_LABEL = 'label_detail/trm_control_oe_check',
  RISK_RESPONSE = 'risk/trm_risk_response',
  TRUST_PORTAL_ACCESS_REQUESTS = 'pending_requests/trm_trust_portal_access_grant',
  TRUST_PORTAL_GRANTED_REQUESTS = 'granted_requests/trm_trust_portal_access_grant',
  TRUST_PORTAL_DOCUMENT_DOWNLOADS = 'downloads/trm_trust_portal_document_download',
  TRUST_PORTAL_FAQ_CLICKS = 'faq_clicks/trm_trust_portal_faq_click',
  TRUST_PORTAL_SEARCHES = 'searches/trm_trust_portal_search',
  TRUST_PORTAL_TI_CHATS = 'ti_chats/trm_trust_portal_ti_chat',
  TRUST_PORTAL_TI_QUESTIONS = 'ti_questions/trm_trust_portal_ti_question',
  TRUST_PORTAL_UPDATE_SUBSCRIPTIONS = 'tp_subscribe/trm_trust_portal_update_subscription',
  TRUST_PORTAL_UPDATE_UNSUBSCRIPTIONS = 'tp_unsubscribe/trm_trust_portal_update_subscription',
}

// DashboardGroupBy controls how sections are derived for the OE dashboards.
// 'framework' keeps the original behavior; 'labels' switches to label-combination
// sections (backed by the label_overview/label_detail templates).
export enum DashboardGroupBy {
  FRAMEWORK = 'framework',
  LABELS = 'labels',
}

export type DashboardDataPoint = {
  emitter: string
  metric: string
  timestamp: number
  int_value: number
  rollup_type: string
}
